import React from 'react';

export default function EarthIcon({ text, companyStyle }) {
  return (
    <span className="icon-earth">
      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20">
        <defs>
          <circle id="globe" r="9.9" cx="10" cy="10" fill="transparent" stroke={companyStyle.color} strokeWidth="3"></circle>
          <clipPath id="globe-clip">
            <use xlinkHref="#globe"></use>
          </clipPath>
        </defs>
        <g clipPath="url(#globe-clip)">
          <path d="M0 0h63v20H0z" fill={companyStyle.color}></path>
          <g id="continents" transform="matrix(1,0,0,1,-43,0)">
            <path className="island" fill={companyStyle.background} d="M38.86 12.74l-1.3-.82-1.7 1.06-1.3.52-.28 2.47 2.9-.44.7.72 1.32.04 1.7-1.8-1.37-2.75zM24.88 7.53L23.65 6.3H18.4l-1.25 1.23V10l1.24 1.24h2.46v3.7l1.24 2.5h1.24l1.54-2.5v-3.7L26.12 10l-1.24-1.24zM0 0v.3l2.1 2.5 1.33 4.36 1.88.37 2.32 1.73-.77 1.54L9 13.34l.07 3.9 2.1 2.12-.34-2.23 1.23-.68 2-5.2-2.8-2.23-3-1.04-.2.43L6.9 7.18l-.23-2.05 6.3-3.75L13.2 0H0zM.5 8.48H1V9zM41.26 16.32l-.6.7h.5l.72-.94-.5-.4zM42.02 0l.98.3 2.1 2.5 1.33 4.36 1.88.37 2.32 1.73-.77 1.54L52 13.34l.07 3.9 2.1 2.12-.34-2.23 1.23-.68 2-5.2-2.8-2.23-3-1.04-.22.43-1.13-1.23-.24-2.05 6.3-3.75L56.2 0H42.02zM43.5 8.48h.5V9zM61.4 6.3l-1.25 1.23V10l1.24 1.24H63V6.3zM62.4 1.42v1.23h-1.23V3.9l1.24 1.23.6-.6V1.18z"></path>
            <path className="island" fill={companyStyle.background} d="M39.98 3.64L41.84.87 32.8 0H27.8l-2.72.74L21.8.42l-2.4 1v1.23h-1.23V3.9l1.24 1.23 1.25-1.24h3.7v1.23l3.6 3.1 2.6 2 1.9-2.07 2.1 1.8 2.6.66-1.5-1.87L39.4 4.7l-2.55-1.84 1.37-.46 1.77 1.24z"></path>
          <rect x="-10" y="-10" width="0" height="0"></rect></g>
          <use xlinkHref="#globe"></use>
        </g>
        <desc>Created with Snap</desc>
      </svg>
      {text}
    </span>
  );
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/components/Footer/LanguageMenu/EarthIcon.js
 **/